const Config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  /**
   * Socket.IO case-events URL : API_BASE_URL + 'case-events'.
   * e.g. https://orva-uae-dev-api.orva.app/case-events
   */
  get SOCKET_CASE_EVENTS_URL(): string | undefined {
    const base = this.API_BASE_URL;
    if (!base) return undefined;
    const normalized = base.replace(/\/$/, "");
    return `${normalized}/case-events`;
  },
  APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  APP_VERSION: process.env.REACT_APP_VERSION,
  APP_TITLE: process.env.REACT_APP_TITLE,
  EULA_URL: process.env.REACT_APP_EULA_URL,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  COPILOT_CHAT_URL: process.env.REACT_APP_COPILOT_CHAT_URL,
  COPILOT_CLIENT_ID: process.env.REACT_APP_COPILOT_CLIENT_ID,
  COPILOT_CLIENT_SECRET: process.env.REACT_APP_COPILOT_CLIENT_SECRET,
  COPILOT_AGENT_ID: process.env.REACT_APP_COPILOT_AGENT_ID,
};

export default Config;
